'use client';

import { useFormStatus } from 'react-dom';
// import './pop-up.scss';
import { useContext, useEffect, useState, useActionState } from 'react';
import { FaSpinner } from 'react-icons/fa';
import { ImSpinner4 } from 'react-icons/im';
import { ReportContext } from '@/app/providers/reportProvider';
import Image from 'next/image';
import { Input } from '../ui/input';
import captchaImg from '../../../public/captachlogo_48.webp';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { checkDomain } from '@/app/utils/helpers';
import { Label } from '../ui/label';
import { RadioGroup, RadioGroupItem } from '../ui/radio-group';
import { useTranslations } from 'next-intl';

function SubmitButton() {
  const { pending } = useFormStatus();
  const t = useTranslations('sample_popUp.sub_btn');
  return (
    <button
      disabled={pending}
      type="submit"
      className="flex w-3/5 lg:w-1/3 mx-auto justify-center rounded-md bg-gradient-to-r from-orange-500 to-pink-500 px-3 p-2 text-sm font-semibold leading-6 cursor-pointer text-white"
    >
      {pending ? (
        <div className="flex" disabled={pending}>
          <FaSpinner className="animate-spin me-2" size={'20'} />{' '}
          <span>{t('submitting')}..</span>
        </div>
      ) : (
        `${t('text')}`
      )}
    </button>
  );
}

export default function Form({
  formAction,
  formType,
  setIsSubmitted,
  className,
  isGetQuote,
}) {
  const [formState, action] = useActionState(formAction, { success: false });
  const [phone, setPhone] = useState();
  const report = useContext(ReportContext);
  const [isChecked, setIsChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [locationData, setLocationData] = useState({ country: 'IN' });
  const [email, setEmail] = useState('');
  const [isFree, setIsFree] = useState(false);
  const t = useTranslations('sample_popUp');

  useEffect(() => {
    //Get the Geolocation of the user
    async function getLocation() {
      const baseURL =
        process.env.NODE_ENV === 'production'
          ? 'https://www.coherentmi.com'
          : 'http://localhost:3000';
      const res = await fetch(`${baseURL}/api/getClientLocation`);
      const data = await res.json();
      if (res.status === 200) setLocationData(data.location);
    }
    getLocation();
  }, []);

  useEffect(() => {
    if (formState.success) {
      setIsSubmitted(true);
    }
    setEmail('');
  }, [formState]); //eslint-disable-line

  function handleCaptchaClick() {
    setIsLoading(true);

    setTimeout(() => {
      setIsChecked((prev) => !prev);
      setIsLoading(false);
    }, 1500);
  }

  function handleEmailChange(event) {
    const { value } = event.target;
    setEmail(value);
    const isFreeDomain = checkDomain(value);
    if (isFreeDomain) {
      setIsFree(true);
    } else {
      setIsFree(false);
    }
  }

  return (
    <form className={`space-y-1.5 ${className}`} action={action}>
      <input value={formType} type="hidden" name="formType" />
      <input value={report.CustomName} type="hidden" name="CustomName" />
      <input value={report.keyword} type="hidden" name="keyword" />
      <input value={report.newsId} type="hidden" name="reportId" />
      <div
        className={
          isGetQuote
            ? 'lg:grid lg:grid-cols-2 lg:gap-y-2 lg:gap-x-2 space-y-2'
            : 'lg:grid lg:grid-cols-2 lg:gap-x-2 lg:gap-y-1 space-y-2'
        }
      >
        <div className="text-justify">
          <Input
            id="name"
            name="name"
            type="text"
            required
            placeholder={t('name')}
            className="col-span-2 lg:col-span-1 focus:outline-blue-300 bg-white text-black"
          />
          {formState.errors && (
            <p className=" text-red-600 text-start">{formState.errors.name}</p>
          )}
        </div>

        <div className="text-justify">
          <Input
            id="email"
            name="email"
            type="email"
            required
            onChange={handleEmailChange}
            placeholder={t('email')}
            className="col-span-2 lg:col-span-1 peer focus:outline-blue-300 bg-white text-black"
          />
          {email !== '' && (
            <p
              className={`${
                isFree ? 'text-red-500' : 'text-black'
              } text-[11px] mx-auto hidden peer-focus:block`}
            >
              {t('msg')}
            </p>
          )}
          {formState.errors && email === '' ? (
            <p className=" text-red-600 text-start text-[11px]">
              {formState.errors.email}
            </p>
          ) : (
            ''
          )}
        </div>

        <div className="text-justify">
          <PhoneInput
            placeholder={t('phone')}
            name="phone"
            type="tel"
            value={phone}
            onChange={setPhone}
            className="rounded-lg border border-gray-300 focus:outline-blue-300 h-10"
            defaultCountry={locationData.country || 'IN'}
            international
            countryCallingCodeEditable={false}
            error={formState.errors && formState.errors.country}
          />
          {formState.errors && (
            <p className=" text-red-600 text-[11px] text-start text-xs">
              {formState.errors.phone}
            </p>
          )}
        </div>

        <div className="text-justify">
          <Input
            id="designation"
            name="designation"
            type="text"
            required
            placeholder={t('designation')}
            className="col-span-2 lg:col-span-1 focus:outline-blue-300 bg-white text-black"
          />
          {formState.errors && (
            <p className=" text-red-600 text-[11px] text-start text-xs">
              {formState.errors.designation}
            </p>
          )}
        </div>
        {/* <div>
          <select
            id="interest"
            name="interest"
            required
            className=" form-select flex-none w-full rounded p-4 appearance-none border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 "
          >
            <option>Please advise – if the interest is driven by:</option>
            <option value={1}>Personal Knowledge/Curiosity</option>
            <option value={2}>Commercial Application/Business Use Case</option>
          </select>
        </div> */}
        <div className="col-span-2">
          <textarea
            rows={2}
            id="comment"
            name="comment"
            type="text"
            placeholder={t('comment')}
            required
            className="peer block w-full border border-slate-300 rounded-md p-2 bg-white text-gray-900 shadow-sm placeholder:text-gray-400 placeholder:text-sm focus:outline-blue-300"
          />
          {formState.errors && (
            <p className=" text-red-600 text-[12px] my-1 text-start text-xs">
              {formState.message}
            </p>
          )}
        </div>
      </div>
      {!isGetQuote ? (
        <div className="text-start items-center">
          <Label htmlFor="interest" className="text-slate-400 font-normal">
            {t('interest.title')} :
          </Label>
          <RadioGroup
            defaultValue="option-one"
            id="interest"
            name="interest"
            className={'ms-4'}
            required
          >
            <div className="flex items-center space-x-2">
              <RadioGroupItem
                value={
                  'Business Use – Evaluate our sample report before buying the full report'
                }
                id="option-one"
                className={'h-2 w-2 focus:ring-0'}
              />
              <Label htmlFor="option-one" className="!text-xs font-normal">
                {t('interest.business')}
              </Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem
                value={
                  'Personal Use – Explore a sample report to build knowledge'
                }
                id="option-two"
                className={'h-2 w-2 focus:ring-0'}
              />
              <Label htmlFor="option-two" className="!text-xs font-normal">
                {t('interest.personal')}
              </Label>
            </div>
          </RadioGroup>
        </div>
      ) : (
        ''
      )}
      <div className="p-1 px-1 flex flex-row bg-slate-50 border border-gray-300 rounded-lg w-3/5 lg:w-1/2 items-center justify-around">
        <div className="flex flex-row gap-x-2 items-center">
          {isLoading ? (
            <ImSpinner4 className="animate-spin" size={'20'} />
          ) : (
            <input
              type="checkbox"
              id="captcha"
              name="captcha"
              required
              checked={isChecked}
              onChange={handleCaptchaClick}
              disabled={isLoading}
              className={`peer block bg-slate-50 rounded-sm text-green-800 shadow transform ${
                isLoading ? 'opacity-0' : 'opacity-100'
              }`}
            ></input>
          )}
          <span htmlFor="captha" className="text-black text-xs font-light">
            {`${t('captcha')}`}
          </span>
        </div>
        <div className="text-center items-center">
          <Image
            src={captchaImg}
            alt="Captcha"
            title="Captcha"
            className="mx-auto"
            height={20}
            width={20}
          />
          <p className="text-slate-500 font-semibold text-xs -mb-2">
            reCAPTCHA
          </p>
          <span className="text-[10px]">Privacy-Terms</span>
        </div>
      </div>
      <div>
        <SubmitButton />
      </div>
      <div className="flex flex-row text-xs my-2">
        <input
          type="checkbox"
          name="privacypolicy"
          defaultChecked
          required
          className="peer block w-4 rounded-sm border p-2 text-blue-800 shadow "
          id="privaypolicy"
        />
        <p className="form-check-label ms-1 font-light" htmlFor="acknowledge">
          {t('privacy')}{' '}
          <a
            href="https://www.coherentmi.com/privacy-policy"
            className="text-decoration-none text-blue-500 font-medium"
          >
            {t('link')}.
          </a>{' '}
        </p>
      </div>
    </form>
  );
}
